export default {
    // eslint-disable-next-line no-unused-vars
    error(h, conf, key) {
        return <div slot="error" class="image-slot" style='text-align: center;color:#909399'>
            <i style='font-size:40px;'
                class="el-icon-picture-outline"></i>
        </div>
    }
}
